const en = {
  app: {
    name: "StrongFish",
    tagline: "Powerlifting app",
  },
  common: {
    troubleshoot: "Troubleshooting details",
    cm: "cm",
    retry: "Reload",
    create: "Create",
    copy: "Copy",
    copied: "Copied to the clipboard.",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    duplicate: "Duplicate",
    edit: "Edit",
    add: "Add",
    close: "Close",
    refresh: "Refresh",
    confirm: "Confirm",
    search: "Search",
    noResults: "No matches",
    selectAll: "Select all",
    clearSelection: "Clear",
    selectedOne: "1 selected",
    selectedCount: "{{count}} selected",
    selectPlaceholder: "Choose...",
    loading: "Loading...",
    none: "None",
    yes: "Yes",
    no: "No",
    back: "Back",
    actions: "Actions",
    optional: "optional",
    unknown: "?",
    kg: "kg",
    all: "All",
    open: "Open",
    logout: "Log out",
    language: "Language",
    theme: "Theme",
    light: "Light",
    dark: "Dark",
    required: "Required",
  },
  nav: {
    myPrograms: "My programs",
    strength: "Strength",
    find: "Find",
    more: "More",
    feed: "Feed",
    training: "My training",
    oneRms: "My 1RMs",
    healthData: "Fitness data",
    clubs: "Clubs",
    exercises: "Exercises",
    profile: "Profile",
    admin: "Administration",
    settings: "Settings",
    about: "About",
    events: "Calendar",
    documentation: "Documentation",
    search: "Find people",
    messages: "Messages",
    coach: "AI coach",
    invitations: "Invitations",
    contact: "Contact",
    apiKeys: "API keys",
    downloadApp: "Get the Android app",
    downloadAppScan: "Scan this with your phone to download the app.",
    collapseSidebar: "Collapse the menu",
    expandSidebar: "Expand the menu",
  },
  auth: {
    welcomeBack: "Welcome back",
    nameOrUsername: "Give your name and surname, or pick a username - either is enough.",
    accountType: "I am...",
    imAnAthlete: "An athlete",
    imAnAthleteHelp: "You follow the programs your coach writes.",
    imACoach: "A coach",
    imACoachHelp: "You write programs and run clubs. A superadmin confirms this first.",
    coachRequestSent: "Your coach account is waiting for confirmation. You can already use StrongFish as an athlete.",
    scanQr: "Sign in by scanning a QR code",
    scanQrHelp: "Open the API keys page on the web app, create a key, and scan the QR code it shows.",
    scanFailed: "This code doesn't carry a StrongFish configuration.",
    login: "Log in",
    signup: "Sign up",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    name: "First name",
    surname: "Last name",
    forgotPassword: "Forgot your password?",
    resetPassword: "Reset password",
    newPassword: "New password",
    sendResetLink: "Send me a link",
    resetLinkSent: "If this email is registered, a reset link has been sent.",
    passwordUpdated: "Your password has been updated. You can log in now.",
    noAccount: "No account yet?",
    hasAccount: "Already have an account?",
    orContinueWith: "or continue with",
    confirmed: "Your account is confirmed. You can log in.",
    confirmFailed: "This confirmation link is invalid or has expired.",
    confirmBanned: "This account has been banned by an administrator.",
    checkEmail: "Check your inbox: we sent you a link to confirm your account.",
    mfaTitle: "Two-factor authentication",
    mfaCode: "Authentication code",
    mfaCodeHelp: "Enter the 6-digit code from your authenticator app.",
    mfaUseKey: "Use my security key",
    mfaVerify: "Verify",
    heroTitle: "Train the numbers, not the guesswork.",
    heroSubtitle: "RPE-based programs whose loads follow your own current 1RM - written by your coach, recomputed for you.",
    photoCreditBy: "Deadlift at the IPF European Championships. Photo by",
    accountCreated: "Welcome to StrongFish - your account is ready.",
  },
  profile: {
    measures: "About you",
    height: "Height",
    title: "Public profile",
    gender: "Gender",
    genderMale: "Male",
    genderFemale: "Female",
    username: "Username",
    handleHelp: "Your profile is shared at /profile/{{handle}}",
    anonymous: "Browse under my username",
    anonymousHelp: "Other members see your username instead of your name, everywhere - your posts, your messages, your clubs. Your name is kept, just hidden.",
    anonymousNeedsUsername: "Pick a username first: it is the name people will see instead of yours.",
    bio: "Bio",
    bodyweight: "Bodyweight",
    visibility: "Who can see my profile",
    visibilityPublic: "Everyone",
    comments: "{{count}} comments",
    visibilityClubs: "My clubs",
    visibilityPrivate: "My coaches only",
    visibilityHelp: {
      public: "Anyone with the link can see your profile, your bests and your public posts.",
      clubs: "Only people who share a club with you can see your profile.",
      private: "Only the coaches and admins of your clubs can see your profile.",
    },
    birthdate: "Birthdate",
    birthdateHelp: "Once set, your club-mates who can see your profile get your birthday in their calendar.",
    notVisible: "This profile is not visible to you.",
    bests: "Bests",
    total: "Total",
    followers: "Followers",
    following: "Following",
    follow: "Follow",
    unfollow: "Unfollow",
    clubs: "Clubs",
    posts: "Posts",
    noPosts: "No posts yet.",
    notFound: "This profile does not exist, or is not public.",
    memberSince: "Member since {{date}}",
    coach: "Coach",
    athlete: "Athlete",
    superadmin: "Superadmin",
    socials: "Where else to find me",
    socialsHelp: "Your account on each - or paste the address of your profile, and the name is taken out of it.",
    rank: "Rank",
    avatar: "Avatar",
    changeAvatar: "Change avatar",
    saved: "Profile saved.",
  },
  mfa: {
    title: "Two-factor authentication",
    subtitle: "Protect your account with a second factor.",
    totp: "Authenticator app",
    totpEnabled: "Authenticator app enabled",
    totpDisabled: "No authenticator app enrolled",
    enableTotp: "Enable",
    disableTotp: "Disable",
    scanQr: "Scan this QR code with your authenticator app, then enter the code it shows.",
    manualSecret: "Or enter this key manually:",
    securityKeys: "Security keys",
    securityKeysHelp: "USB keys such as a YubiKey, or your device's built-in authenticator.",
    addKey: "Add a security key",
    keyName: "Key name",
    noKeys: "No security key registered",
    keyAdded: "Security key registered.",
    keyRemoved: "Security key removed.",
    totpConfirmed: "Two-factor authentication is on.",
    totpRemoved: "Authenticator app removed.",
    unsupported: "This browser does not support security keys.",
  },
  clubs: {
    title: "Clubs",
    create: "Create a club",
    edit: "Edit club",
    name: "Name",
    description: "Description",
    city: "City",
    country: "Country",
    logo: "Logo",
    members: "Members",
    memberCount: "{{count}} members",
    owner: "Owner",
    admin: "Admin",
    member: "Member",
    role: "Role",
    addMember: "Add a member",
    addMemberHelp: "Search by email, profile name or full name. The person must already have an account.",
    invite: "Invite someone",
    inviteHelp: "They get an email with a link. If they have no account yet, the invitation waits until they create one with this address.",
    inviteMessage: "A word for them",
    sendInvitation: "Send the invitation",
    invitationSent: "Invitation sent.",
    pendingInvitations: "Waiting for an answer",
    withdrawInvitation: "Withdraw the invitation",
    promote: "Make admin",
    demote: "Make member",
    remove: "Remove from club",
    leave: "Leave this club",
    transfer: "Transfer ownership",
    transferHelp: "The new owner must already be a member. You will become an admin.",
    empty: "You are not in any club yet.",
    emptyCoach: "Create your first club to start coaching.",
    created: "Club created.",
    saved: "Club saved.",
    deleted: "Club deleted.",
    memberAdded: "Member added.",
    memberRemoved: "Member removed.",
    confirmDelete: "Delete the club \"{{name}}\"? Its programs and posts will be deleted too.",
    confirmRemove: "Remove {{name}} from the club?",
    confirmLeave: "Leave the club \"{{name}}\"?",
    feed: "Club feed",
    feedback: "Feedback",
  },
  programs: {
    pickMembers: "Pick members",
    assignCount: "Assign to {{count}}",
    mine: "My programs",
    mineSubtitle: "The blocks you wrote for yourself.",
    mineEmptyTitle: "No programs of your own yet",
    mineEmptyBody: "Write one, or copy a program from one of your clubs and adapt it.",
    new: "New program",
    exportPdf: "PDF sheet",
    export: "Export",
    exportXlsx: "Excel spreadsheet (.xlsx)",
    exportPng: "Image to share (.png)",
    exportWeek: "Export this week",
    exportBlock: "Export the whole block",
    exporting: "Preparing...",
    copy: "Copy",
    copied: "Program copied",
    move: "Move",
    moved: "Program moved",
    moveInstead: "Move it instead of copying",
    copyHelp: "A copy has its own sessions, so editing it leaves the original alone.",
    destination: "Where to",
    moveNeedsElsewhere: "A move needs a different destination - this is where the program already is.",
    pickDestination: "Pick a club",
    myLibrary: "My own programs",
    visibility: "Who can see it",
    visibilityPrivate: "Only me",
    visibilityPrivateHelp: "Nobody else can open it.",
    visibilityClubs: "My clubs",
    visibilityClubsHelp: "The people you train with can open it.",
    visibilityPublic: "Anyone with the link",
    visibilityPublicHelp: "Shareable outside the app.",
    importOptional: "Import a spreadsheet (optional)",
    title: "Programs",
    import: "Import a spreadsheet",
    importHelp:
      "Upload the coach's .xlsx. Two layouts are read automatically: one sheet per week, each session starting with an \"Exercice | Reps | RPE | Percentage | Load\" header row; or one sheet per block, with an \"EXERCICES | SÉRIES/REPS | RPE\" header and a W1..Wn column per week. Any weights the file works out itself are ignored - loads are always recomputed from each athlete's own maxes.",
    importing: "Importing...",
    imported: "Program imported: {{weeks}} weeks, {{days}} sessions, {{sets}} sets.",
    createdExercises: "New exercises added to the catalog: {{list}}",
    referenceOneRms: "This file was written for these maxes:",
    useAsMyOneRms: "Use as my 1RMs",
    warnings: "Notes about this file",
    programName: "Program name",
    // The create form and the rename modal both label their fields with
    // these; they were missing, so the labels rendered as their own keys.
    name: "Name",
    description: "Description",
    empty: "No program in this club yet.",
    weeks: "{{count}} weeks",
    sessions: "{{count}} sessions",
    setCount: "{{count}} sets",
    author: "By {{name}}",
    week: "Week {{week}}",
    public: "Shared publicly",
    private: "Private",
    publicHelp: "Anybody with the link can read this program, without an account.",
    privateHelp: "Only this club's members can read this program.",
    publish: "Share publicly",
    unpublish: "Make private",
    published: "This program is now public. Anybody with the link can read it.",
    unpublished: "This program is private again. The shared link no longer works.",
    copyLink: "Copy the link",
    day: "Day {{day}}",
    assign: "Assign",
    assignTo: "Assign this program",
    assigned: "Program assigned.",
    assignmentsSaved: "Assignments updated.",
    unassign: "Unassign",
    assignments: "Assigned to",
    noAssignments: "Not assigned to anyone yet.",
    startDate: "Start date",
    note: "Note for the athlete",
    deleted: "Program deleted.",
    confirmDelete: "Delete the program \"{{name}}\"? Every assignment and logged set goes with it.",
    saved: "Program saved.",
    viewAs: "Viewing as",
    myself: "Myself",
    create: "Create a program",
    createHelp: "Start empty and add sessions, or import a coach's spreadsheet.",
    created: "Program created.",
    addSession: "Add a session",
    editSession: "Edit session",
    sessionSaved: "Session saved.",
    sessionDeleted: "Session deleted.",
    confirmDeleteSession: "Delete week {{week}} day {{day}} and its sets?",
    noSessions: "No session yet. Add the first one.",
    addSet: "Add a set",
    duplicateSet: "Duplicate this set",
    duplicateSession: "Copy this session and its sets onto the same day of the next free week",
    reorderSession: "Drag to reorder this session",
    dropSetHere: "Drop a set here",
    reorderHelp: "Drag a set by its handle to reorder it, or onto another session to move it there. Sessions move the same way, by the handle next to their title.",
    editSet: "Edit set",
    setSaved: "Set saved.",
    setDeleted: "Set deleted.",
    confirmDeleteSet: "Delete this set?",
    edit: "Edit the program",
    done: "Done editing",
    buildMode: "Edit program",
  },
  session: {
    aiFeedbackAgain: "Another reading",
    aiFeedback: "AI feedback",
    aiFeedbackHelp: "Ask the AI to read this session against the ones before it.",
    aiFeedbackLocked: "Finish the session - every set logged - to ask for a reading.",
    exercise: "Exercise",
    reps: "Reps",
    rpe: "RPE",
    percentage: "%",
    load: "Load",
    onTheBar: "On the bar",
    e1rm: "e1RM",
    part: "Part",
    from1rm: "from your {{lift}} 1RM of {{value}}kg",
    fromTodaysE1rm: "from the {{value}}kg you just showed on this lift, not from your recorded 1RM",
    perceivedRpe: "Felt like",
    exportWeek: "Export this week",
    exportSession: "Export this session",
    exportBlock: "Export the block",
    recordOnStance: "Record on Stance",
    stanceRecordCopied: "Load copied — open Stance and enter it.",
    markDone: "Mark as done",
    markUndone: "Mark as not done",
    markDayDone: "Mark the whole session done",
    markDayUndone: "Mark the whole session not done",
    rpePlaceholder: "RPE",
    autoregulated: "Recalculated from what you just lifted",
    bodyweight: "Bodyweight",
    beltless: "Beltless",
    beltlessQuestion: "Beltless?",
    absolute: "Fixed load",
    missingOneRm: "Enter your 1RM to see the loads",
    missingOneRmsList: "Loads are missing for: {{list}}",
    setMyOneRms: "Enter my 1RMs",
    log: "Log this set",
    logged: "Set logged.",
    actualReps: "Reps done",
    actualRpe: "RPE felt",
    actualLoad: "Load used",
    loggedLoad: "The load you logged for this set.",
    loggedLoadPlanned: "The load you logged for this set. Planned: {{value}}.",
    loggedReps: "The reps you logged for this set.",
    loggedRepsPlanned: "The reps you logged for this set. Planned: {{value}}.",
    comment: "Comment for your coach",
    done: "Done",
    clearLog: "Clear",
    yourE1rm: "Your estimated 1RM for this set: {{value}}kg",
    beatsMax: "That is above your recorded max.",
    progress: "{{done}} / {{total}} sets done",
    status: "Status",
    statusActive: "In progress",
    statusDone: "Finished",
    statusArchived: "Archived",
    noAssignments: "No program has been assigned to you yet.",
    noAssignmentsHelp: "Your coach assigns programs from your club.",
    loadMode: "How is it loaded?",
    loadModeRpe: "Reps at an RPE (from the 1RM)",
    loadModePercentage: "A percentage of the 1RM",
    loadModeAbsolute: "A fixed weight",
    loadModeBodyweight: "Bodyweight",
    loadModeHelp: "An RPE prescription is resolved against each member's own max; a percentage is applied to it as-authored.",
    absoluteLoad: "Weight",
    notes: "Notes",
    week: "Week",
    day: "Day",
    title: "Title",
  },
  oneRms: {
    title: "My 1RMs",
    subtitle:
      "Every prescribed load is computed from these. Update one and your whole program recalculates.",
    lift: "Lift",
    value: "1RM",
    updated: "Updated",
    history: "History",
    save: "Save",
    saved: "1RM updated.",
    removed: "1RM removed.",
    empty: "No max recorded yet.",
    addLift: "Add a lift",
    mainLifts: "Competition lifts",
    otherLifts: "Other movements",
    confirmDelete: "Remove your 1RM for {{name}}?",
  },
  exercises: {
    title: "Exercise catalog",
    subtitle: "Shared by every coach. Add a movement once and everyone can program it.",
    create: "Add an exercise",
    edit: "Edit exercise",
    name: "Name",
    labelEn: "Name (English)",
    labelFr: "Name (French)",
    aliases: "Alternative names",
    aliasesHelp: "Comma-separated. Spreadsheets using these spellings will import onto this exercise.",
    category: "Category",
    categorySquat: "Squat",
    categoryBench: "Bench",
    categoryDeadlift: "Deadlift",
    categoryAccessory: "Accessory",
    oneRmRef: "Loads computed from",
    oneRmRefHelp: "Which competition max a percentage or RPE prescription resolves against.",
    oneRmRefNone: "No max (fixed load)",
    bodyweight: "Loaded by bodyweight",
    created: "Exercise added.",
    saved: "Exercise saved.",
    deleted: "Exercise deleted.",
    confirmDelete: "Delete \"{{name}}\" from the catalog?",
    empty: "No exercise matches.",
    main: "Competition movement",
    mainHelp: "Members are prompted to record a 1RM for it, and derived movements resolve their loads against it. Superadmin only.",
    adminOnly: "Only a superadmin can edit or delete a catalog entry - it is shared by every club.",
    usageWarning: "Deleting {{name}} will also delete {{sets}} prescribed sets across {{programs}} programs, and {{oneRms}} recorded 1RMs. This cannot be undone.",
    usageNone: "{{name}} is not used by any program yet.",
    checkingUsage: "Checking what this would affect...",
  },
  feed: {
    title: "Feed",
    discover: "Discover",
    following: "Following",
    compose: "Share something with your club...",
    post: "Post",
    posted: "Posted.",
    visibility: "Visibility",
    visibilityPublic: "Everyone",
    visibilityClub: "Club only",
    pickClub: "Pick a club",
    pickClubs: "Pick clubs",
    addPicture: "Add a picture",
    addVideo: "Add a video",
    uploadingVideo: "Uploading the video... {{percent}}%",
    like: "Like",
    liked: "Liked",
    comment: "Comment",
    comments: "{{count}} comments",
    editedAt: "edited {{date}}",
    ownPostLikes: "Likes on your post. You cannot like your own.",
    writeComment: "Write a comment...",
    empty: "Nothing here yet. Follow someone, or join a club.",
    emptyDiscover: "No public post yet.",
    edited: "Edited",
    report: "Report",
    reported: "Reported. A moderator will look at it.",
    reportReason: "Why are you reporting this?",
    reportSpam: "Spam",
    reportAbuse: "Abuse or harassment",
    reportInappropriate: "Inappropriate content",
    reportOther: "Other",
    reportComment: "Anything to add?",
    confirmDeletePost: "Delete this post?",
    confirmDeleteComment: "Delete this comment?",
    postDeleted: "Post deleted.",
    commentDeleted: "Comment deleted.",
    postUnavailable: "This post is not available. It may have been deleted, or shared only with a club.",
    joinToReply: "Join StrongFish to like this post and reply to it.",
    likes: "{{count}} likes",
  },
  admin: {
    title: "Administration",
    users: "Users",
    clubs: "Clubs",
    reports: "Moderation",
    coachRequests: "Coach requests",
    searchUsers: "Search accounts",
    makeRole: "Make {{role}}",
    ips: "Connection addresses",
    ipsTitle: "{{name}}'s connections",
    ipsHelp: "Every address this account has connected from, and how often. Blocking one is the firewall's job, not this screen's.",
    ip: "Address",
    ipCount: "Connections",
    ipFirstSeen: "First seen",
    ipLastSeen: "Last seen",
    noIpsTitle: "No connection recorded",
    noIpsBody: "Addresses are recorded when this account signs in.",
    confirmCoach: "Confirm",
    rejectCoach: "Reject",
    rejectCoachTitle: "Reject this coach request?",
    rejectCoachHelp: "{{name}} is emailed your reason, so write it for them.",
    rejectCoachPlaceholder: "We could not verify your coaching credentials...",
    coachApproved: "This account is now a coach.",
    coachRejected: "The request was rejected and the applicant was told why.",
    noCoachRequestsTitle: "No coach waiting",
    noCoachRequestsBody: "When somebody signs up as a coach, their request shows up here.",
    stats: "Overview",
    totalUsers: "Accounts",
    openReports: "Open reports",
    role: "Role",
    roleSuperadmin: "Superadmin",
    roleCoach: "Coach",
    roleConfirmed: "Athlete",
    roleDisabled: "Pending",
    roleBan: "Banned",
    editUser: "Edit account",
    newPassword: "New password (leave blank to keep)",
    clearMfa: "Reset two-factor",
    clearMfaHelp: "Removes every second factor, for a user who lost their phone and key.",
    mfaCleared: "Two-factor reset.",
    userSaved: "Account saved.",
    userDeleted: "Account deleted.",
    confirmDeleteUser: "Delete {{email}}? Their clubs, programs and posts go with them.",
    reportStatus: "Status",
    reportOpen: "Open",
    reportResolved: "Resolved",
    reportDismissed: "Dismissed",
    reportedBy: "Reported by",
    reportTarget: "Content",
    resolveAndDelete: "Delete the content",
    dismiss: "Dismiss",
    resolve: "Resolve",
    resolved: "Report handled.",
    noReports: "Nothing to moderate.",
  },
  devices: {
    lift: { squat: "Squat", bench: "Bench", deadlift: "Deadlift" },
    pairKey: {
      garmin: {
        label: "Garmin personal API key",
        hint: "Generate a personal API key in Garmin Connect (it is shown once). It is kept on this server to read your Garmin data.",
      },
    },
    pair: {
      password: "Stance password",
      stance: { email: "Stance email" },
    },
    record: "Record a set",
    recordHint: "Opens the Stance app to track a set, then shows it here.",
    recordFailed: "Could not open the Stance app. Is it installed?",
    barSpeed: {
      title: "Bar speed - last set",
      empty: "No tracked set yet. Record one in the Stance app and it shows here.",
      load: "{{weight}} kg x {{reps}}",
      rpePair: "RPE {{given}} felt, {{real}} measured",
      rpeReal: "measured RPE {{real}}",
      rep: "Rep {{n}}",
      mean: "Mean speed",
      peak: "Peak speed",
      velocityLoss: "Velocity loss",
      legendMean: "mean",
      legendPeak: "peak",
    },
    provider: {
      "google-health": "Google Health (Fitbit, Pixel Watch)",
      withings: "Withings",
      garmin: "Garmin",
      stance: "Stance Fitness",
    },
    aiFeedbackWindow: "over the last {{days}} days",
    aiFeedback: "AI reading",
    aiFeedbackAsk: "Ask the AI",
    aiFeedbackAgain: "Ask again",
    aiFeedbackHelp: "A reading of the last 90 days: activity, heart rate and body composition.",
    aiFeedbackEmpty: "No reading yet. The AI can look at your last 90 days whenever you ask.",
    title: "Connected devices",
    subtitle: "Read what your watch and your scale already measured. Nothing is written back, and nothing is stored here.",
    accounts: "Accounts",
    connect: "Connect",
    connectGoogle: "Connect with Google",
    connectGoogleHint: "Finish signing in with Google in the web app.",
    disconnect: "Disconnect",
    notConnected: "Not connected.",
    unavailable: "Not enabled on this server.",
    connectedSince: "Connected since {{date}}.",
    total: "Total steps",
    dailyAverage: "Average per 24h",
    perDay: "Day by day",
    averageBpm: "Average heart rate",
    peakBpm: "Highest heart rate",
    noHeartRate: "No heart rate recorded over this range.",
    heartRangeTooWide: "Heart rate only goes back 14 days, so this longer view shows steps alone. The last reading is above.",
    latestBpm: "Last heart rate",
    export: "Export this view",
    bpm: "bpm",
    activityFrom: "Steps and heart rate are shown from {{provider}}.",
    bodyComposition: {
      title: "Body composition",
      empty: "No measurement from your scale yet.",
      takenOn: "Measured on {{date}}",
      measure: {
        weight: "Weight",
        bmi: "BMI",
        fatRatio: "Body fat",
        fatMass: "Fat mass",
        fatFreeMass: "Fat-free mass",
        muscleMass: "Muscle mass",
        hydration: "Body water",
        boneMass: "Bone mass",
        visceralFat: "Visceral fat",
        basalMetabolicRate: "Basal metabolic rate",
      },
    },
    zone: {
      light: "Light",
      moderate: "Moderate",
      vigorous: "Vigorous",
      peak: "Peak",
    },
    range: {
      "24h": "Last 24h",
      "48h": "Last 48h",
      week: "Last week",
      "14d": "Last 14 days",
      month: "Last month",
      "90d": "Last 90 days",
    },
    outcome: {
      connected: "Account connected.",
      denied: "You declined the request, so nothing was connected.",
      not_linked: "That Google account has no Google Health profile yet. Link your Fitbit in the Google Health app, then connect again.",
      invalid_state: "That link had expired. Please start again.",
      missing_code: "The provider sent no authorization back. Please try again.",
      unavailable: "This integration is not enabled on this server.",
      exchange_failed: "The provider refused the connection. If you administer this server, the reason is in its logs.",
      account_failed: "You are signed in, but your data could not be read. If you administer this server, check that the provider's API is enabled for this application - the reason is in the logs.",
      store_failed: "The connection could not be saved. Please try again.",
    },
  },
  errors: {
    invalidHeight: "Please enter a height in centimetres.",
    aiNotConfigured: "Connect an AI provider in your settings first.",
    aiRefused: "Your AI provider refused the request. Check the key, the model and your quota.",
    invalidAiProvider: "Pick an AI provider.",
    invalidAiBaseUrl: "The address must be an http or https URL.",
    aiKeyRequired: "An API key is required.",
    invalidAiRole: "This member cannot be given that access.",
    sessionIncomplete: "Finish the session before asking for a reading of it.",
    conversationTitleRequired: "Please give this conversation a title.",
    nothingSelected: "Pick what to delete first.",
    generic: "Something went wrong. Please try again.",
    nameOrUsername: "Give a name and surname, or pick a username.",
    copyFailed: "Could not copy to the clipboard.",
    apiKeyDescription: "Please say what this key is for.",
    invalidExpiration: "Please enter a valid expiration date.",
    configTokenRequired: "The API key token is missing.",
    storageNotConfigured: "Set up your own video storage in the settings before uploading a video.",
    storageUploadFailed: "Your storage rejected this upload. Check the bucket and its credentials.",
    storageDownloadFailed: "This file could not be read from the storage. It may have been deleted, or the credentials changed.",
    videoTooLarge: "This video is too large.",
    videoTooLargeMax: "This video is too large. The limit is {{size}}.",
    unsupportedVideo: "This file is not a video a browser can play. Use MP4, WebM or MOV.",
    invalidStorageType: "Unknown storage type.",
    invalidStorageRole: "Pick reader or writer.",
    invalidServiceAccount: "This service account key could not be read.",
    eventTitleRequired: "Please give this event a title.",
    invalidEventDate: "Please check the event's dates.",
    invalidCalendarFile: "This file could not be read as a season calendar.",
    invalidBirthdate: "Please enter a valid birthdate.",
    invalidProfileVisibility: "Unknown profile visibility.",
    invitationNotFound: "This invitation is no longer available.",
    alreadyInvited: "This person has already been invited.",
    noCoachRequest: "This account has no pending coach request.",
    rejectMotiveRequired: "Please say why this request is rejected.",
    cannotMessage: "You cannot message this member.",
    cannotMessageSelf: "You cannot message yourself.",
    cannotBlockSelf: "You cannot block yourself.",
    emptyMessage: "A message needs some text.",
    internal: "Something went wrong. Please try again.",
    screenTitle: "This screen ran into a problem",
    screenBody:
      "Something on this page failed to display. The rest of the app still works - pick another screen from the menu, or reload to try this one again.",
    notFound: "Not found.",
    invalidRequestBody: "Invalid request.",
    allFieldsRequired: "Please fill in every field.",
    invalidCredentials: "Wrong email or password.",
    duplicateEmail: "This email is already in use.",
    duplicateHandle: "This profile name is already taken.",
    invalidEmail: "Please enter a valid email address.",
    deviceNotConnected: "No account is connected yet.",
    deviceNotLinked: "That account has no Google Health profile yet. Link your watch in the Google Health app.",
    deviceReauthorize: "The connection has expired. Connect the account again.",
    invalidRange: "That time range is not available.",
    deviceUnavailable: "This integration is not enabled on this server.",
    upstream: "The provider could not be reached. Try again in a moment.",
    invalidHandle: "This profile name cannot be used.",
    invalidUsername: "This username cannot be used.",
    duplicateUsername: "This username is already taken.",
    usernameRequired: "Pick a username to browse anonymously.",
    userNotFound: "User not found.",
    noUserWithEmail: "No account is registered with this email.",
    passwordsMismatch: "The passwords do not match.",
    passwordTooShort: "Your password must be at least 8 characters long.",
    passwordNoUpper: "Your password must contain an uppercase letter.",
    passwordNoLower: "Your password must contain a lowercase letter.",
    passwordNoSymbol: "Your password must contain a special character.",
    invalidToken: "This link is invalid or has expired.",
    invalidMfaCode: "Invalid code.",
    imageTooLarge: "This image is too large.",
    invalidRole: "Invalid role.",
    cantEditOwnRole: "You cannot change your own role.",
    cantDeleteOwnAccount: "You cannot delete your own account.",
    nameRequired: "Please enter a name.",
    cantRemoveOwner: "The club owner cannot be removed or demoted.",
    alreadyMember: "This person is already in the club.",
    notAClubMember: "This person is not a member of the club.",
    duplicateExercise: "An exercise with this name already exists.",
    exerciseInUse: "This exercise is used by a program and cannot be deleted.",
    invalidCategory: "Invalid category.",
    invalidOneRm: "A 1RM must be greater than zero.",
    invalidSet: "This set is incomplete.",
    invalidLoadMode: "Invalid load mode.",
    invalidStatus: "Invalid status.",
    uploadTooLarge: "This file is too large.",
    invalidSpreadsheet: "This file could not be read as a spreadsheet.",
    noProgramInFile: "No training day was found in this spreadsheet.",
    emptyPost: "A post needs some text, a picture or a link.",
    invalidVisibility: "Invalid visibility.",
    clubRequired: "Please pick a club for a club-only post.",
    cannotLikeOwnPost: "You cannot like your own post.",
    emptyComment: "A comment needs some text.",
    invalidReportTarget: "Invalid report.",
    reportReasonRequired: "Please say why you are reporting this.",
    forbidden: "You are not allowed to do this.",
    accountDisabledAdmin: "Your account is waiting for an administrator to activate it.",
    accountDisabledEmail: "Please confirm your account with the link we emailed you.",
    accountBanned: "Your account has been banned by an administrator.",
    network: "The server is unreachable. Please try again.",
    contactFormNotConfigured: "The contact form is not available on this instance.",
    contactFormFailed: "Your message could not be sent. Please try again later.",
    contactRateLimited: "You have sent too many messages. Please try again later.",
    contactMessageTooShort: "Your message is too short - please tell us a little more.",
    contactGibberish: "Your message was flagged as spam. Please rewrite it.",
  },
  about: {
    title: "About",
    unavailable: "This page has not been written yet.",
    openSource: "StrongFish is an open-source (MIT) product by CWCloud. Sources are available",
    openSourceLink: "here",
  },
  apiKeys: {
    title: "API keys",
    openApi: "API reference",
    intro:
      "An API key authenticates a script - or this app on your phone - with an X-Api-Key header instead of a password. It carries exactly your own permissions, so treat it like one.",
    create: "Create a key",
    description: "What is it for?",
    descriptionPlaceholder: "My phone, my export script...",
    expiresAt: "Expires on",
    neverExpires: "Never expires",
    expiresOn: "Expires on {{date}}",
    emptyTitle: "No API key yet",
    emptyBody: "Create one to sign in on your phone by scanning a QR code, or to reach the API from a script.",
    createdTitle: "Your new API key",
    createdWarning: "Copy it now: only its fingerprint is stored, so this is the only time it will ever be shown.",
    downloadConfig: "Download the config file",
    showQr: "Show the QR code",
    hideQr: "Hide the QR code",
    qrHelp: "Scan this in the mobile app to sign that device in.",
    revoke: "Revoke",
    revokeTitle: "Revoke this key?",
    revokeBody: "\"{{description}}\" will stop working immediately, everywhere it is used.",
    revoked: "The key has been revoked.",
  },
  events: {
    title: "Calendar",
    subtitle: "Meets, club sessions and camps - subscribe to it from your own calendar.",
    add: "Add an event",
    edit: "Edit the event",
    eventTitle: "Title",
    kindLabel: "Type",
    kind: {
      competition: "Competition",
      training: "Training",
      other: "Other",
    },
    club: "Club",
    noClub: "Open calendar (everyone)",
    startsAt: "Starts",
    endsAt: "Ends",
    location: "Where",
    url: "More information",
    description: "Details",
    color: "Colour",
    allDay: "All day",
    import: "Import a calendar",
    importHelp: "Upload the federation's season calendar - the PDF year planner or the spreadsheet. Its competitions are read out with their dates and their disciplines.",
    importing: "Reading the calendar…",
    imported: "{{count}} competitions imported",
    importSkipped: "{{count}} were already in your calendar",
    importWarnings: "These were found but carried no date, so add them by hand:",
    lastDay: "Last day",
    visibility: "Who can see it",
    visibilityPublic: "Everyone",
    visibilityPrivate: "Only me",
    visibilityPrivateHelp: "Kept to your own calendar. Nobody else sees it, apart from an administrator.",
    visibilityClub: "Club members only",
    showPast: "Show past events",
    calendarLayout: "Calendar",
    listLayout: "List",
    monthView: "Month",
    weekView: "Week",
    today: "Today",
    previous: "Previous",
    next: "Next",
    more: "+{{count}} more",
    dragHint: "Drag down a day to pick a start and end time, or click a half hour.",
    moreInfo: "More information",
    emptyTitle: "Nothing planned",
    emptyBody: "No event is coming up. A coach can add one for their club.",
    created: "Event added.",
    updated: "Event updated.",
    deleted: "Event deleted.",
    deleteTitle: "Delete this event?",
    deleteBody: "\"{{title}}\" will disappear from everyone's calendar, including the feeds already subscribed to it.",
    subscribeTitle: "Subscribe from Outlook or Google Calendar",
    subscribeBody:
      "Add this address as a calendar subscription and your events show up alongside the rest of your week, kept up to date automatically.",
    enableFeed: "Get my calendar address",
    disableFeed: "Turn the feed off",
    copyFeed: "Copy the address",
    regenerateFeed: "Generate a new address",
    feedRegenerated: "A new address was generated. The old one no longer works.",
    feedWarning:
      "Anybody holding this address can read your calendar - it is the only credential there is. Generate a new one if it gets out.",
  },
  update: {
    upToDate: "You are on the latest version",
    available: "Version {{version}} is available",
    help: "Downloads the new build and hands it to Android to install. You stay signed in.",
    install: "Update",
    downloading: "Downloading the update...",
    failed: "The update could not be downloaded or installed. Please try again later.",
  },
  ai: {
    orderHelp: "The first one answers when you do not pick. Move yours to say which.",
    first: "answers by default",
    moveUp: "Move up",
    moveDown: "Move down",
    generatedBy: "Generated by {{connection}} on {{date}}",
    deleteFeedback: "Delete this reading",
    deleteFeedbackConfirm: "Delete this reading? It cannot be brought back - you would have to ask for a new one.",
    deleteConversationConfirm: "Delete this conversation? Everything in it goes with it.",
    connection: "AI connection",
    askWith: "Ask with",
    modelHelp: "Pick one of your provider's models, or type any name it serves.",
    defaultConnection: "Default",
    title: "AI connections",
    subtitle:
      "Connect a model to ask it about your training. It is your own account and your own key - and you can lend it to other members, the way you lend a storage.",
    noConnections: "No AI connected yet.",
    addConnection: "Add a connection",
    name: "Name",
    namePlaceholder: "My {{provider}} key",
    providerLabel: "Provider",
    baseUrl: "Address",
    baseUrlHelp:
      "Where the requests go. Change it to point at a gateway of your own - a LiteLLM, an Ollama, an OpenRouter account.",
    model: "Model",
    token: "API key",
    tokenSet: "A key is already saved",
    tokenHelp: "The key from your provider. It is kept on the server and never sent back to the browser.",
    tokenKeep: "Leave this empty to keep the key already saved.",
    saved: "Connection saved.",
    cleared: "Connection removed.",
    clear: "Remove this connection",
    shares: "Who else can use it",
    sharesHelp:
      "Lend your connection to other members: they can put questions through it, and nothing else. They never see the key.",
    noShares: "Nobody else uses this connection.",
    shareWith: "Members",
    pickMembers: "Pick members",
    shareAction: "Share",
    shared: "Connection shared.",
    unshare: "Stop sharing",
    role: { user: "Can ask" },
    sharedBy: "shared by {{name}}",
    coachTitle: "AI coach",
    coachSubtitle:
      "Ask about your training. The answers come from your own AI connection, and every conversation is kept here.",
    connectOne: "Connect one",
    newConversation: "New conversation",
    noConversations: "No conversation yet.",
    exchangeCount: "{{count}} exchanges",
    exchangeOne: "1 exchange",
    sharedBadge: "shared",
    pickConversation: "Select this conversation",
    deletePicked: "Delete ({{count}})",
    clearAll: "Delete everything",
    clearAllConfirm: "Delete every conversation? This cannot be undone.",
    deletedCount: "{{count}} conversations deleted.",
    rename: "Rename",
    shareLink: "Share a link",
    unshareLink: "Stop sharing the link",
    shareLinkHelp: "Anybody with this link can read the conversation. Press the link button again to revoke it.",
    exportConversation: "Export the conversation",
    emptyTitle: "Ask your coach",
    emptyBody: "Programming, technique, recovery, meet day - ask anything about your lifting.",
    thinking: "Thinking...",
    placeholder: "Ask a question...",
    send: "Send",
    sharedSubtitle: "A conversation shared from StrongFish.",
  },
  storage: {
    clearConfirm: "Remove this storage? The files already in it stay where they are, but the app will not be able to read them.",
    serviceAccountPaste: "Paste the contents of the JSON key file.",
    noTargets: "No storage configured yet.",
    addTarget: "Add a storage",
    orderHelp: "An upload goes to every target. The link in the post comes from the first one.",
    first: "the link comes from here",
    moveUp: "Move up",
    moveDown: "Move down",
    private: "This bucket is not public",
    privateHelp:
      "Turn this on when your bucket refuses public files: nothing is made public as it is written. Either way, files in a bucket are always served by StrongFish itself, with your credentials, to the people your profile is visible to - and to anybody you share the storage with. A Google Drive target is different: its files are posted as Drive links, reachable by anyone holding them.",
    shares: "Who else can use it",
    sharesHelp:
      "Lend your storage to other members: a reader can play what is in it, a writer can upload to it as well. Your own uploads always go to your own storage first.",
    noShares: "Nobody else uses this storage.",
    shareWith: "Members",
    pickMembers: "Pick members",
    roleLabel: "They may",
    role: {
      owner: "Owner",
      writer: "Upload and play",
      reader: "Play",
    },
    shareAction: "Share",
    shared: "Storage shared.",
    unshare: "Stop sharing",
    title: "Video storage",
    subtitle:
      "StrongFish keeps no video of its own, so posting one means using your own storage. Up to {{size}} MB per video.",
    type: "Where to store them",
    typeS3: "S3-compatible bucket",
    typeDrive: "Google Drive folder",
    endpoint: "Endpoint",
    region: "Region",
    bucket: "Bucket",
    accessKey: "Access key",
    secretKey: "Secret key",
    publicBaseUrl: "Public address",
    publicBaseUrlHelp: "Set this if the bucket is served through a CDN or a domain of your own.",
    folderId: "Folder id",
    serviceAccount: "Service account key",
    serviceAccountHelp:
      "The JSON key file Google gives you. Share the Drive folder with that account's address first, or it cannot write to it.",
    serviceAccountSet: "A key is already configured. Pick a file to replace it.",
    pathHelpS3: "A prefix inside the bucket. Leave it empty to write at the bucket's root.",
    pathHelpDrive:
      "A subfolder inside the Drive folder, created if it does not exist yet. Nest it with slashes, like strong-fish/videos. Leave it empty to write straight into the folder.",
    serviceAccountReadError: "That file could not be read. Pick the JSON key Google gave you.",
    path: "Subfolder",
    clear: "Remove this configuration",
    saved: "Storage saved.",
    cleared: "Storage configuration removed.",
  },
  messages: {
    title: "Messages",
    current: "Conversations",
    findSomeone: "Find someone",
    record: "Record a voice message",
    stopRecording: "Stop recording",
    recordingUnsupported: "This browser cannot record audio.",
    microphoneDenied: "Microphone access was refused.",
    subtitle: "Private conversations with the members you can see.",
    message: "Message",
    send: "Send",
    placeholder: "Write a message...",
    emptyTitle: "No conversation yet",
    emptyBody: "Open somebody's profile and message them to start one.",
    pickTitle: "Pick a conversation",
    pickBody: "Choose someone on the left, or start one from their profile.",
    threadEmpty: "No message yet. Say hello.",
    report: "Report this message",
    reportTitle: "Report this message",
    reportHelp: "Moderators cannot read your conversation, so the message is sent with your report.",
    reportPlaceholder: "What is wrong with this message?",
    reported: "Reported. A moderator will look at it.",
    deleteTitle: "Delete this message?",
    deleteBody: "It is removed for both of you, and cannot be brought back.",
    deleted: "Message deleted",
  },
  blocks: {
    title: "Blocked members",
    subtitle: "Blocked people cannot message you, and their posts stay out of your feed.",
    block: "Block",
    blockTitle: "Block this member?",
    blockBody: "{{name}} will not be able to message you, and their posts will disappear from your feed. You can undo this at any time.",
    blocked: "Member blocked.",
    unblock: "Unblock",
    unblocked: "Member unblocked.",
    since: "Blocked on {{date}}",
    emptyTitle: "Nobody blocked",
    emptyBody: "Members you block show up here, so you can let them back in.",
  },
  share: {
    label: "Share",
    on: "Share on {{network}}",
    copyLink: "Copy the link",
    profileText: "{{name}} on StrongFish",
    postText: "Seen on StrongFish",
  },
  search: {
    title: "Find people",
    subtitle: "Search by name, surname or email. You only see the profiles their owners let you see.",
    terms: "Search",
    termsPlaceholder: "A name, a username, a profile name, an email...",
    submit: "Search",
    advanced: "Search by field",
    simple: "Simple search",
    clear: "Clear",
    results: "{{count}} people found",
    sharesClub: "In one of your clubs",
    openProfile: "Open the profile",
    startTitle: "Who are you looking for?",
    startBody: "Type a name, a profile name or an email address above.",
    noneTitle: "Nobody found",
    noneBody: "Nobody matches that - or their profile is not visible to you.",
  },
  invitations: {
    title: "Invitations",
    subtitle: "Clubs that asked you to join them.",
    emptyTitle: "No invitation",
    emptyBody: "When a coach invites you to their club, it shows up here.",
    from: "Invited by {{name}}",
    asRole: {
      member: "You would join as a member.",
      admin: "You would join as an admin.",
    },
    accept: "Accept",
    decline: "Decline",
    accepted: "You joined {{club}}.",
    declined: "Invitation declined.",
  },
  publicProgram: {
    notFoundTitle: "This program is not available",
    notFoundBody: "It may have been unpublished, or the link may be wrong.",
    loadsNotice:
      "This is the prescription as written: sets, reps and effort. Weights are worked out from each athlete's own maxes, so sign in and run it against yours.",
  },
  cookieBanner: {
    title: "Cookie notice",
    message: "StrongFish is an open-source (MIT) product. The cookies and local storage it uses are required only for the app to function (sign-in, your theme and language) - never for tracking or analytics.",
    understand: "I understand",
  },
  contact: {
    title: "Contact us",
    body: "A question, a bug, or feedback on the app? Send us a message.",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    sent: "Your message has been sent. Thank you!",
  },
  strength: {
    title: "Strength calculator",
    subtitle: "What a total is worth, on the three coefficients the sport ranks by.",
    unit: "Units",
    kg: "kg",
    lb: "lb",
    unitHelp: "Enter every weight in the units you picked. The scores are the same either way.",
    division: "Division",
    raw: "Raw",
    equipped: "Equipped",
    bodyweight: "Bodyweight",
    squat: "Squat",
    bench: "Bench press",
    deadlift: "Deadlift",
    total: "Total",
    dots: "DOTS",
    wilks: "Wilks (1994)",
    ipfGl: "IPF GL points",
    enterLifts: "Enter a bodyweight and at least one lift to see the scores.",
    tierFrom: "{{value}} DOTS",
    percentile: "Ahead of {{value}}% of the {{sample}} lifters here who have recorded all three lifts.",
    strongerThan: "Stronger than",
    noPopulation: "Nobody here has recorded all three lifts yet, so there is nothing to compare against.",
    noBadges: "No badge yet. Record your three maxes to start earning them.",
    tiers: {
      novice: "Iron Recruit",
      intermediate: "Platform Contender",
      advanced: "National Caliber",
      elite: "Master Lifter",
      worldClass: "Titan",
    },
    badges: {
      multiplier: {
        squat2x: "2x bodyweight squat",
        bench1_5x: "1.5x bodyweight bench",
        deadlift2_5x: "2.5x bodyweight deadlift",
        total10x: "10x bodyweight total",
      },
      club: {
        total1000lb: "1000 lb club",
        total500kg: "500 kg club",
        total1500lb: "1500 lb club",
      },
      dots: {
        300: "300 DOTS club",
        400: "400 DOTS club",
        500: "500 DOTS club",
      },
      style: {
        squatDominant: "Squat specialist",
        deadliftDominant: "Deadlift specialist",
      },
    },
  },
};

export default en;
